export default {
    path : "officebuilding-item-success",
    name : "officebuilding-item-success",
    meta : {
        title : "全体成功项目"
    },
    component: () => import('@/pages/officebuilding/success/Index'),
    redirect: {
        name : "officebuilding-item-success-whole"
    },
    children: [
        {
            path: 'all',
            name: 'officebuilding-item-success-whole',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'recent',
            name: 'officebuilding-item-success-recent',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'atme',
            name: 'officebuilding-item-success-atme',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'meat',
            name: 'officebuilding-item-success-meat',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'reply',
            name: 'officebuilding-item-success-reply',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'search',
            name: 'officebuilding-item-success-search',
            meta: {
                title: '写字楼项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/officebuilding/successitem/index.js